import React, { useContext } from "react";

import { GlobalStateContext } from "./App";



export default function Programa() {
    const {
        item,
        setidProgram,
        visibleCount, 
        setVisibleCount,
    } = useContext(GlobalStateContext);

    const SelectProgram = (idProgram) => {
        setidProgram(idProgram);
    }

    const handleLoadMore = () => {
        setVisibleCount((prev) => prev + 20);
    };

    const Items = item.slice(0, visibleCount);

    return (
        <>
            <div> <strong> Resultados ( {item.length >= 0 ? item.length : 0} ) </strong></div>

            <div className="list-posec-items">
                <ul className="feature-list">
                    {Items.map((val, index) => (
                        <li className="item-prosec" key={index}>
                            <a onClick={() => SelectProgram(val.id_programa)}>
                                <h3>{val.programa}</h3>
                            </a>
                        </li>
                    ))}
                </ul>

            {visibleCount < item.length && (
                <button className="btn btn-default"  onClick={handleLoadMore}>
                    Ver más
                </button>
            )}
            </div>
       

        </>

    );

}
